import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ApiError, SubscriptionError } from '../types';

interface SubscriptionErrorContextType {
  subscriptionError: SubscriptionError | null;
  setSubscriptionError: (error: SubscriptionError | null) => void;
  clearSubscriptionError: () => void;
}

const SubscriptionErrorContext = createContext<SubscriptionErrorContextType | undefined>(undefined);

export const SubscriptionErrorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [subscriptionError, setSubscriptionError] = useState<SubscriptionError | null>(null);

  const clearSubscriptionError = () => {
    setSubscriptionError(null);
  };

  return (
    <SubscriptionErrorContext.Provider
      value={{
        subscriptionError,
        setSubscriptionError,
        clearSubscriptionError,
      }}
    >
      {children}
    </SubscriptionErrorContext.Provider>
  );
};

export const useSubscriptionError = (): SubscriptionErrorContextType => {
  const context = useContext(SubscriptionErrorContext);
  if (context === undefined) {
    throw new Error('useSubscriptionError must be used within a SubscriptionErrorProvider');
  }
  return context;
};